import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useEditVideoMutation } from '../../features/videos/videosApi';

const VideoEditModalContent = ({ title, description, id, url, views, duration, createdAt, setIsOpen }) => {
    const [updateVideo, { isLoading, isSuccess, isError, data }] = useEditVideoMutation()
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const onSubmit = data => {
        data.createdAt = createdAt
        data.id = id
        updateVideo(data);
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success('successfully updated')
            setIsOpen(false)
        }
        if (isError) {
            toast.error('something went wrong while deleting')
        }

    }, [isSuccess, isError])
    return (
        <div className='w-full flex '>
            <form onSubmit={handleSubmit(onSubmit)} className='w-full '>
                <label htmlFor="title">Title:</label>
                <input defaultValue={title} className='login-input  marker:' type="text" id="title" {...register("title", { required: true })} />

                {errors.title && <span>This field is required</span>}

                <label htmlFor="description">Description:</label>
                <input defaultValue={description} type="text" className='login-input' id="description" {...register("description", { required: true })} />

                <label htmlFor="url">URL:</label>
                <input type="text" defaultValue={url} className='login-input' id="url" {...register("url", { required: true, pattern: /^(https:\/\/www\.youtube\.com\/embed\/|https:\/\/player\.vimeo\.com\/video\/)[^ "]+$/, })} />
                {errors.url?.type === "pattern" && (
                    <p className='text-error'>Please enter a valid youtube Video URL</p>
                )}

                <label htmlFor="views">Views:</label>
                <input type="text" className='login-input' defaultValue={views} id="views" {...register("views", { required: true })} />

                <label htmlFor="duration">Duration:</label>
                <input type="text" className='login-input' defaultValue={duration} id="duration" {...register("duration", { required: true })} />

                <button disabled={isLoading} className='mt-5 py-2 px-5 rounded-md border border-blue-500' type="submit">Submit</button>
            </form>
        </div>
    );
};

export default VideoEditModalContent;